export enum WebEventsEnum {
  ErrorMessage = 'ErrorMessage',
  WarehouseIdUpdated = 'WarehouseIdUpdated',
  UpdateCheckoutProfileAddress = 'UpdateCheckoutProfileAddress',
}
